exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect {\n  background: url('data:image/svg+xml;utf8,<svg fill=\"%23c1c1c1\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>')\n    no-repeat right 1em center / 24px auto white;\n}\n.gestao-usuarios .v-expansion-panel__container--active\n> .v-expansion-panel__header\n.v-expansion-panel__header__icon\ni:before {\n    content: \"\\F068\";\n}\n", ""]);

// exports
